<template>
  <div class="tw-w-full">
    <label v-if="label" class="tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500">
      {{ label }}
    </label>

    <div v-if="isEditing" class="tw-w-full tw-flex tw-items-stretch">
      <span
        v-if="prefix"
        class="tw-inline-flex tw-items-center tw-rounded-l-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-3 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5"
      >
        {{ prefix }}
      </span>
      <input
        :value="modelValue ?? value"
        :placeholder="placeholder"
        type="text"
        class="tw-w-full tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 tw-transition placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55"
        :class="[
          prefix && suffix ? 'tw-border-l-0 tw-border-r-0' : '',
          prefix && !suffix ? 'tw-rounded-r-xl tw-border-l-0' : '',
          suffix && !prefix ? 'tw-rounded-l-xl tw-border-r-0' : '',
          !prefix && !suffix ? 'tw-rounded-xl' : '',
        ]"
        @input="updateInput"
      />
      <span
        v-if="suffix"
        class="tw-inline-flex tw-items-center tw-rounded-r-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-3 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5"
      >
        {{ suffix }}
      </span>
    </div>

    <div v-else class="tw-min-h-[40px] tw-flex tw-items-center tw-text-sm tw-text-slate-800">
      <span class="tw-truncate">{{ modelValue ?? value }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    isEditing: {
      default: false,
    },
    prefix: {
      type: String,
      default: undefined,
    },
    suffix: {
      type: String,
      default: undefined,
    },
    modelValue: {
      type: [String, Number],
      default: undefined,
    },
    value: {
      type: [String, Number],
    },
    placeholder: {
      default: undefined,
    },
    label: {
      default: undefined,
    },
  },
  emits: ['input', 'update:modelValue'],
  methods: {
    updateInput(value) {
      const vm = (this as any);

      if (typeof value === 'string') {
        vm.$emit('input', value);
        vm.$emit('update:modelValue', value);
      } else {
        vm.$emit('input', value.target.value);
        vm.$emit('update:modelValue', value.target.value);
      }
    },
  },
} as any);
</script>
